import { createApp } from "vue";
import ComponentModelsRural from "./ComponentModelsRural.vue";

const app = createApp({
  components: {
    "component-models-rural": ComponentModelsRural,
  },
}).mount("#container-models-rural");
